import http from '@/services/http'
import { userUrl } from '../url'

export interface StockLocation {
  locationId?: string
  locationName?: string
  address1?: string
  address2?: string
  /**
   * 国家/地区编码
   */
  countryCode?: string
  /**
   * 一级行政区
   */
  province?: string
  /**
   * 二级行政区
   */
  city?: string
  /**
   * 邮编
   */
  zip?: string
}

export interface BindStockLocation extends StockLocation {
  storeLocationId: string
  deductedForcibly?: boolean
}

/**
 * 寄方信息
 */
export interface ShipmentInfoDTO {
  /** 寄件人姓名 */
  senderName?: string
  /** 寄件人电话 */
  senderPhone?: string
  /** 寄件人手机 */
  senderMobile?: string
  /** 寄件人英文姓名 */
  senderEnName?: string
  /**订单价格设置 1-优先订单（默认） 2-取ow
   */
  skuPriceSetting?: 1 | 2
}

interface EccangExtraInfoDTO {
  /**（约束：元素个数范围：[0,256]） */
  serviceTypeCode: string
  /**（约束：元素个数范围：[0,256]） */
  serviceToken: string
  /**（约束：元素个数范围：[0,256]） */
  appKey: string
  /**（约束：元素个数范围：[0,256]） */
  secretKey: string
  /**（约束：元素个数范围：[0,256]） */
  serviceId: string
  /**（约束：元素个数范围：[0,256]） */
  providerCode: string
  /**（约束：元素个数范围：[1,50]） */
  warehouseIds: string[]
}

interface PlatformExtraInfoDTO {
  eccang?: EccangExtraInfoDTO
}
export interface StoreInfoDto {
  /** 平台店铺id */
  storeId: string

  /** 店铺id */
  storeInfoId: string

  /**  销售平台 */
  source: string
  /** 店铺名称 */
  storeName: string

  currency?: string
  /** 寄方信息 */
  shipmentInfo?: ShipmentInfoDTO

  /** 库存地址 */
  locationName?: StockLocation['locationName']

  /** 是否开启SHOPLINE邮件模版  */
  platformEmailSwitch?: 0 | 1

  /**平台扩展配置 */
  extraInfo?: PlatformExtraInfoDTO
}

export interface StoreListResponse {
  /** 店铺列表 */
  list?: StoreInfoDto[]
}

export interface LocationCheckResult {
  /**
   * 地点是否失效
   */
  valid: boolean
  /**
   * 库存是否存在
   */
  stockExisted: boolean
}

/**
 * 查询店铺绑定列表
 * @returns
 */
export const getStoreList = () => http.admin.get<StoreListResponse>(userUrl.bindStoreList)

/**
 * 支持库存地点的平台
 * @returns
 */
export const getSupportStockLocationPlatform = () => http.admin.get<string[]>(userUrl.supportLocationPlatform)

/**
 * 查询店铺可以使用的地址列表
 * @param payload
 * @returns
 */
export const queryStockLocationList = (payload: { storeSeq: string; source: string }) =>
  http.admin.post<{
    locations?: StockLocation[]
  }>(userUrl.queryLocationList, payload)

/**
 * 店铺地点校验
 * @param payload
 * @returns
 */
export const checkLocation = (payload: { storeSeq: string; source: string; locationId: string }) => http.admin.post<LocationCheckResult>(userUrl.checkLocation, payload)

export const updateStoreStockLocation = (payload: { storeSeq: string; source: string; locationId: string; deductedForcibly: boolean }) =>
  http.admin.post(userUrl.setStockLocation, payload)

export const clearStoreStockLocation = (payload: { storeSeq: string; source: string }) => http.admin.post(userUrl.clearStockLocation, payload)

export const getStoreStockLocation = (payload: { storeSeq: string; source: string }) => http.admin.post<BindStockLocation>(userUrl.storeStockLocationDetail, payload)
